import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Brand } from "@/components/Brand";
import { LogOut } from "lucide-react";
import { PanicButton } from "@/components/PanicButton";

/** Layout simple para el portal de solo lectura del cliente final. */
export default function ClienteLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const onLogout = async () => { await logout(); nav("/login"); };

  return (
    <div style={{ minHeight: "100vh", background: "var(--invict-bone)" }}>
      <header style={{
        background: "#0A0A0A", color: "#FFFBF4", padding: "16px 20px",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        position: "sticky", top: 0, zIndex: 40,
      }}>
        <Brand size="sm" />
        <button onClick={onLogout} style={{
          background: "transparent", border: "1px solid rgba(255,251,244,0.2)",
          color: "rgba(255,251,244,0.7)", padding: "6px 12px", borderRadius: 2,
          fontSize: 11, letterSpacing: "0.05em", textTransform: "uppercase", fontWeight: 700,
          display: "inline-flex", alignItems: "center", gap: 6, cursor: "pointer",
        }} data-testid="logout-button">
          <LogOut size={12} /> Salir
        </button>
      </header>
      <div style={{ padding: "10px 4px 4px", color: "var(--invict-text-muted)" }}>
        <div style={{ padding: "10px 20px", fontSize: 11, letterSpacing: "0.1em", textTransform: "uppercase", fontWeight: 700 }}>
          Hola, <span style={{ color: "var(--invict-black)" }}>{user?.name}</span> · Portal del cliente
        </div>
        <Outlet />
      </div>
      {user?.role === "inquilino" && user?.client_access?.length > 0 && <PanicButton />}
    </div>
  );
}
